import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withKeys as _withKeys, mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: /*@__PURE__*/_normalizeClass({
                    'd-flex': true,
                    'input-container': true
                })
}
const _hoisted_2 = ["type", "name", "value", "placeholder"]

import InputWrapperWithIcon from "~/chat/vue/widget/form/fields/InputWrapperWithIcon.vue";
import {ITextField} from "~/cabinet/vue/interface/form/elements/Interfaces";
import ChatTextInputSuggest from "~/chat/vue/widget/form/fields/ChatTextInputSuggest.vue";
import {useChatFormInput, useChatFormInputProps} from "~/chat/vue/widget/form/fields/useChatFormInput";
import {computed} from "vue";


const __default__ = {
    name: "ChatTextInput"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    ...useChatFormInputProps<ITextField>(),
    inputType: {
        type: String,
        default: "text"
    },
    additionalInputAttributes: {
        required: false,
        type: Object
    }
},
  emits: ["update:modelValue", "continue"],
  setup(__props, { expose: __expose, emit: __emit }) {

let props = __props;

let emits = __emit;

let {exposedObject, placeholder} = useChatFormInput(props);

__expose(exposedObject);

let dimension = computed(() => {
    return props.field.dimension
});

function onEnter() {
    if (!props.required || props.modelValue) {
        emits("continue");
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InputWrapperWithIcon, {
    field: _ctx.field,
    required: _ctx.required
  }, {
    default: _withCtx(() => [
      _createVNode(ChatTextInputSuggest, {
        field: _ctx.field,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_unref(emits)('update:modelValue', $event))),
        "model-value": _ctx.modelValue
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("input", _mergeProps({
              ref: "input",
              type: __props.inputType,
              class: {
                        'with-icon': _ctx.field.icon,
                        error: _ctx.error,
                        filler: true,
                        input: true,
                        'ym-disable-keys': true,
                        'with-dimension': !!_unref(dimension),
                    },
              name: _ctx.field.name,
              value: _ctx.modelValue,
              onInput: _cache[0] || (_cache[0] = ($event: any) => (_unref(emits)('update:modelValue', $event.target.value))),
              onKeyup: _withKeys(onEnter, ["enter"]),
              placeholder: _unref(placeholder)
            }, __props.additionalInputAttributes ?? {}), null, 16, _hoisted_2),
            (_unref(dimension))
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "dimension like-input",
                  style: _normalizeStyle(_unref(props))
                }, _toDisplayString(_unref(dimension)), 5))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["field", "model-value"])
    ]),
    _: 1
  }, 8, ["field", "required"]))
}
}

})